import { CommonErrorType } from '../../common/enums';
import { addEmptyFieldValidationError, addValidationError } from '../../common/utils/errorUtils';
import { fieldCantBeEmptyMsg, incorrectPasswordMsg, t } from '../../common/i18n';
import type { CommonError } from '../../common/types/errors';

export interface ChangePasswordFormValues {
  confirmNewPassword?: string;
  currentPassword?: string;
  newPassword?: string;
}

export function getErrorsFromChangePasswordFormComponent(
  data: ChangePasswordFormValues,
  validationErrors?: CommonError[]
): CommonError[] | undefined {
  const errors: CommonError[] = [];
  if (data) {
    if (data.confirmNewPassword?.trim() !== data.newPassword?.trim() && !validationErrors) {
      addValidationError(errors, t.JTM7(`Passwords don't match`), '');
      return errors;
    }
    if (data.currentPassword?.trim() === data.newPassword?.trim() && !validationErrors) {
      addValidationError(errors, t.FUDM(`Current password and new password shouldn't be the same`), '');
      return errors;
    }
    if (!data.confirmNewPassword || data.confirmNewPassword.trim().length === 0) {
      addEmptyFieldValidationError(errors, 'confirmNewPassword', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!data.newPassword || data.newPassword.trim().length === 0) {
      addEmptyFieldValidationError(errors, 'newPassword', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!data.currentPassword || data.currentPassword.trim().length === 0) {
      addEmptyFieldValidationError(errors, 'currentPassword', t.VPVR(fieldCantBeEmptyMsg));
    }
  }
  if (errors.length === 0) {
    return validationErrors;
  }
  return errors.concat(validationErrors || []);
}

export const getErrorsFromChangePasswordFailedResponse = (ajaxErrors?: CommonError[]): CommonError[] | undefined => {
  if (ajaxErrors && ajaxErrors[0]?.type === CommonErrorType.UNPROCESSABLE_ENTITY) {
    const errors: CommonError[] = [];
    addValidationError(errors, t.NH72(incorrectPasswordMsg), 'currentPassword');
    return errors;
  }
  return ajaxErrors;
};
